export enum actionTypes {
    SET_FORM_ERROR = 'BANK_ID_AUTH:FORM_ERROR:SET',
    SET_IS_RECAPTCHA_SHOWN = 'BANK_ID_AUTH:RECAPTCHA_SHOWN:SET',
    SET_IS_EXTERNAL_SCRIPT_LOADED = 'BANK_ID_AUTH:IS_EXTERNAL_SCRIPT_LOADED:SET',
    SET_IS_WAITING_FOR_BANK_ID_CONFIRMATION = 'BANK_ID_AUTH:IS_WAITING_FOR_BANK_ID_CONFIRMATION:SET'
}
